/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_Catalog_PdfInputs */

const cs_templates_kind_catalog_pdf = /** @type {(inputs: Templates_Kind_Catalog_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog nemovitosti`)
};

const en_templates_kind_catalog_pdf = /** @type {(inputs: Templates_Kind_Catalog_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property catalog`)
};

/**
* | output |
* | --- |
* | "Property catalog" |
*
* @param {Templates_Kind_Catalog_PdfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_catalog_pdf = /** @type {((inputs?: Templates_Kind_Catalog_PdfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_Catalog_PdfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_catalog_pdf(inputs)
	return cs_templates_kind_catalog_pdf(inputs)
});